const ACLFeatureFlagTypePolicy = {
  ACLFeatureFlag: {
    keyFields: ({ uid }) => uid,
  },
};

export default ACLFeatureFlagTypePolicy;
